(() => {
  let Wishlist = window.HMWishlist;

  const pageRoot = document.querySelector(".wishlist-page");
  if (!pageRoot) return;

  let hasStarted = false;

  function getCartComponent() {
    return document.querySelector("cart-notification") || document.querySelector("cart-drawer");
  }

  async function waitFor(conditionFn, interval = 50, timeout = 1400) {
    return new Promise((resolve) => {
      const start = Date.now();

      (function check() {
        try {
          if (conditionFn()) return resolve(true);
        } catch {}

        if (Date.now() - start >= timeout) return resolve(false);
        window.setTimeout(check, interval);
      })();
    });
  }

  function removeDrawerHideStyles(root = document) {
    try {
      Array.from(root.querySelectorAll("style")).forEach((styleEl) => {
        const text = (styleEl.textContent || "").toLowerCase();
        if (text.includes(".drawer") && text.includes("visibility") && text.includes("hidden")) {
          styleEl.remove();
        }
      });

      Array.from(document.head.querySelectorAll("style")).forEach((styleEl) => {
        const text = (styleEl.textContent || "").toLowerCase();
        if (text.includes(".drawer") && text.includes("visibility") && text.includes("hidden")) {
          styleEl.remove();
        }
      });
    } catch {}
  }

  async function executeScriptsFromHtml(htmlString) {
    try {
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlString, "text/html");
      const scripts = Array.from(doc.querySelectorAll("script"));
      const loads = [];

      for (const script of scripts) {
        const src = script.getAttribute("src");
        const hasInlineCode = script.textContent && script.textContent.trim().length > 0;

        if (src) {
          const alreadyExists = Array.from(document.querySelectorAll("script[src]")).some(
            (el) => el.getAttribute("src") === src
          );

          if (alreadyExists) continue;

          loads.push(
            new Promise((resolve) => {
              const node = document.createElement("script");
              node.src = src;
              node.async = false;
              node.onload = () => resolve(src);
              node.onerror = () => resolve(src);
              document.head.appendChild(node);
            })
          );
        } else if (hasInlineCode) {
          const node = document.createElement("script");
          node.text = script.textContent;
          document.head.appendChild(node);
        }
      }

      if (loads.length) await Promise.all(loads);
    } catch {}
  }

  async function cartAddItemsDawn(items, source = "wishlist") {
    if (!items || !items.length) return null;

    const cart = getCartComponent();

    let config;

    if (typeof fetchConfig === "function") {
      config = fetchConfig("javascript");
      if (!config.headers) config.headers = {};
      config.headers["X-Requested-With"] = "XMLHttpRequest";
      delete config.headers["Content-Type"];
    } else {
      config = {
        method: "POST",
        headers: { "X-Requested-With": "XMLHttpRequest" }
      };
    }

    const formData = new FormData();

    items.forEach((item, index) => {
      formData.append(`items[${index}][id]`, String(item.id));
      formData.append(`items[${index}][quantity]`, String(item.quantity || 1));
    });

    if (cart && typeof cart.getSectionsToRender === "function") {
      try {
        const sections = cart.getSectionsToRender().map((section) => section.id).filter(Boolean);

        if (sections.length) {
          formData.append("sections", sections.join(","));
        }

        formData.append("sections_url", window.location.pathname);

        if (typeof cart.setActiveElement === "function") {
          cart.setActiveElement(document.activeElement);
        }
      } catch {}
    }

    config.body = formData;

    const addUrl =
      window.routes?.cart_add_url ||
      (typeof routes !== "undefined" && routes.cart_add_url) ||
      "/cart/add";

    const response = await fetch(addUrl, config);
    const data = await response.json().catch(() => null);

    if (!response.ok || data?.status) {
      const message = data?.description || data?.message || "There was an error adding items to the cart.";
      throw new Error(message);
    }

    if (cart && typeof cart.renderContents === "function") {
      try {
        cart.renderContents(data);
      } catch {}

      removeDrawerHideStyles(cart);

      try {
        const cartHtml = data?.sections?.["cart-drawer"];
        if (cartHtml) await executeScriptsFromHtml(cartHtml);
      } catch {}

      try {
        if (Array.isArray(data.items) && data.items.length > 0) {
          cart.classList.remove("is-empty");

          const emptyPlaceholder = cart.querySelector(".cart-drawer__empty, .drawer__empty, .cart-empty");
          if (emptyPlaceholder) emptyPlaceholder.remove();
        }
      } catch {}

      await waitFor(() => {
        try {
          if (!cart) return false;
          if (cart.querySelector(".cart-item") && cart.querySelector("#CartDrawer-Form")) return true;
          return (cart.innerHTML || "").trim().length > 180;
        } catch {
          return false;
        }
      });

      try {
        if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source,
            productVariantId: items[0]?.id,
            cartData: data
          });
        } else {
          document.dispatchEvent(new CustomEvent("cart:updated", { detail: { source, cartData: data } }));
        }
      } catch {}

      try {
        if (typeof cart.open === "function") cart.open();
      } catch {
        window.setTimeout(() => {
          try {
            if (typeof cart.open === "function") cart.open();
          } catch {}
        }, 120);
      }
    } else {
      const cartUrl =
        window.routes?.cart_url ||
        (typeof routes !== "undefined" && routes.cart_url) ||
        "/cart";

      window.location = cartUrl;
    }

    return data;
  }

  async function fetchWishlistCard(handle, variantId) {
    const params = new URLSearchParams();
    params.set("view", "wishlist-card");

    if (variantId) {
      params.set("variant", String(variantId));
    }

    const response = await fetch(`/products/${encodeURIComponent(handle)}?${params.toString()}`, {
      credentials: "same-origin"
    });

    if (!response.ok) {
      throw new Error(`Could not load wishlist item: ${handle}`);
    }

    return response.text();
  }

  async function hydrateWishlistVariants(container, entries) {
    const itemEls = Array.from(container.querySelectorAll("[data-wishlist-item]"));
    if (!itemEls.length) return;

    const handles = [...new Set(entries.map((entry) => entry.handle))];

    const products = await Promise.allSettled(
      handles.map((handle) =>
        fetch(`/products/${encodeURIComponent(handle)}.js`, { credentials: "same-origin" }).then((response) => {
          if (!response.ok) throw new Error(`Could not load product JSON: ${handle}`);
          return response.json();
        })
      )
    );

    const byHandle = new Map();

    products.forEach((result, index) => {
      if (result.status === "fulfilled") {
        byHandle.set(handles[index], result.value);
      }
    });

    itemEls.forEach((itemEl, index) => {
      const entry = entries[index];
      if (!entry) return;

      const product = byHandle.get(entry.handle);
      if (!product) return;

      const wantedId = entry.variantId ? Number(entry.variantId) : null;

      const variant =
        (wantedId ? product.variants.find((v) => Number(v.id) === wantedId) : null) ||
        product.variants.find((v) => v.available) ||
        product.variants[0];

      if (!variant) return;

      itemEl.setAttribute("data-product-handle", entry.handle);
      itemEl.setAttribute("data-variant-id", String(variant.id));
      itemEl.setAttribute("data-price", String(Number(variant.price || 0)));
      itemEl.setAttribute("data-saved-variant-id", wantedId ? String(wantedId) : "");

      const titleEl = itemEl.querySelector("[data-wishlist-variant-title]");
      if (titleEl) {
        titleEl.textContent = variant.title && variant.title !== "Default Title" ? variant.title : "";
      }

      const priceEl = itemEl.querySelector("[data-wishlist-variant-price]");
      if (priceEl) {
        priceEl.textContent = Wishlist.moneyFormat(Number(variant.price || 0));
      }

      const addButton = itemEl.querySelector("[data-wishlist-add-to-cart]");
      if (addButton) {
        addButton.disabled = !variant.available;
      }
    });
  }

  function wishlistNeedsHydration(container) {
    const items = container.querySelectorAll("[data-wishlist-item]");
    if (!items.length) return false;

    for (const item of items) {
      const variantId = item.getAttribute("data-variant-id");
      const price = item.getAttribute("data-price");

      if (!variantId || !price) {
        return true;
      }
    }

    return false;
  }

  function freezeHeight(el) {
    if (!el) return;

    const height = el.getBoundingClientRect().height;
    el.style.minHeight = `${height}px`;
  }

  function unfreezeHeight(el) {
    if (!el) return;
    el.style.minHeight = "";
  }

  async function renderWishlistPage() {
    const container = pageRoot.querySelector("[data-wishlist-items]");
    const empty = pageRoot.querySelector("[data-wishlist-empty]");
    const totalItemsEl = pageRoot.querySelector("[data-wishlist-total-items]");
    const totalPriceEl = pageRoot.querySelector("[data-wishlist-total-price]");
    const controls = pageRoot.querySelector("[data-wishlist-controls]");

    if (!container) return;

    const entries = Wishlist.read();

    freezeHeight(container);
    container.classList.add("is-loading");

    if (!entries.length) {
      container.innerHTML = "";

      if (empty) empty.hidden = false;
      if (totalItemsEl) totalItemsEl.textContent = "0";
      if (totalPriceEl) totalPriceEl.textContent = Wishlist.moneyFormat(0);
      if (controls) controls.hidden = true;

      container.classList.remove("is-loading");
      unfreezeHeight(container);
      return;
    }

    if (empty) empty.hidden = true;
    if (controls) controls.hidden = false;

    const results = await Promise.allSettled(
      entries.map((entry) => fetchWishlistCard(entry.handle, entry.variantId))
    );

    container.innerHTML = results
      .filter((result) => result.status === "fulfilled")
      .map((result) => result.value)
      .join("");

    Wishlist.setButtonsState(container);

    if (wishlistNeedsHydration(container)) {
      await hydrateWishlistVariants(container, entries);
    }

    let total = 0;
    const items = container.querySelectorAll("[data-wishlist-item]");

    items.forEach((item) => {
      const cents = parseInt(item.getAttribute("data-price") || "0", 10);
      if (!Number.isNaN(cents)) total += cents;
    });

    if (totalItemsEl) totalItemsEl.textContent = String(items.length);
    if (totalPriceEl) totalPriceEl.textContent = Wishlist.moneyFormat(total);

    container.classList.remove("is-loading");
    unfreezeHeight(container);
  }

  function initPageActions() {
    pageRoot.addEventListener("click", async (event) => {
      const removeButton = event.target.closest("[data-wishlist-remove]");

      if (removeButton) {
        const item = removeButton.closest("[data-wishlist-item]");
        const handle = item?.getAttribute("data-product-handle");
        const savedVariantId = Number(item?.getAttribute("data-saved-variant-id") || 0) || null;

        if (handle) {
          Wishlist.remove(handle, savedVariantId);
        }

        return;
      }

      const clearButton = event.target.closest("[data-wishlist-clear]");

      if (clearButton) {
        Wishlist.write([]);
        return;
      }

      const addButton = event.target.closest("[data-wishlist-add-to-cart]");

      if (addButton) {
        addButton.disabled = true;

        try {
          const item = addButton.closest("[data-wishlist-item]");
          const variantId = parseInt(item?.getAttribute("data-variant-id") || "0", 10);

          if (variantId) {
            await cartAddItemsDawn([{ id: variantId, quantity: 1 }], "wishlist");
          }
        } catch (error) {
          alert(error.message || "Could not add to cart.");
        } finally {
          addButton.disabled = false;
        }

        return;
      }

      const addAllButton = event.target.closest("[data-wishlist-add-all]");

      if (addAllButton) {
        addAllButton.disabled = true;

        try {
          const items = Array.from(pageRoot.querySelectorAll("[data-wishlist-item]"))
            .map((item) => parseInt(item.getAttribute("data-variant-id") || "0", 10))
            .filter(Boolean)
            .map((id) => ({ id, quantity: 1 }));

          if (items.length) {
            await cartAddItemsDawn(items, "wishlist");
          }
        } catch (error) {
          alert(error.message || "Could not add all items to cart.");
        } finally {
          addAllButton.disabled = false;
        }
      }
    });

    window.addEventListener(Wishlist.EVENT_NAME, renderWishlistPage);

    window.addEventListener("storage", (event) => {
      if (event.key !== Wishlist.STORAGE_KEY) return;
      Wishlist.refreshCache();
      renderWishlistPage();
    });
  }

  function init() {
    initPageActions();
    renderWishlistPage();
  }

  function boot(attempt = 0) {
    Wishlist = window.HMWishlist;

    if (!Wishlist) {
      if (attempt < 80) {
        window.setTimeout(() => boot(attempt + 1), 50);
      } else {
        console.warn("Wishlist page could not start because window.HMWishlist was not found.");
      }

      return;
    }

    if (hasStarted) return;
    hasStarted = true;

    init();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => boot());
  } else {
    boot();
  }
})();